// ----------------------------
// Virtual Market
// ----------------------------

// ------------------------------------
// Imports
// ------------------------------------
import { put, call, takeLatest, all } from 'redux-saga/effects'
import {
  GET_PRODUCTS_BY_MARKET, getProductsByMarketSucceeded, getProductsByMarketFailed,
  GET_PRODUCTS_BY_BENEFIT, getProductsByBenefitSucceeded, getProductsByBenefitFailed,
  FINISH_PURCHASE, finishPurchaseSucceeded, finishPurchaseFailed,
  GET_RESULTS_PDF, getResultsPDFSucceeded, getResultsPDFFailed
} from '../modules/module_products.js'
import {
  sendMetricsSucceeded, sendMetricsFailed
} from '../modules/module_metrics.js'
import { sendMetricsUser} from 'services/metrics-api'
import { API_REQUEST_STATUS_SUCCEEDED, API_REQUEST_STATUS_FAILED } from 'services/config'
import { doCallback, getProductsByDepartment, getProductsByBenefit } from 'utilities/general-utils'
import { updateMarketStorage } from 'utilities/session-utils'
import protocols from 'common-protocols'

// ------------------------------------
// Services
// ------------------------------------

import { fetchProductsByMarketImages, finishPurchase, getResultsPDF } from 'services/products-api'

// ------------------------------------
// Sagas
// ------------------------------------

/* Sagas - Workers */
function* getProductsByMarketRequested(action) {

  const { response, error } = yield call(fetchProductsByMarket, action.token, action.idMarket, action.idPais);

  let actionToDo = null;
  let productsByDepartment = {};
  let message = API_REQUEST_STATUS_FAILED;

  if(response) {
    message = API_REQUEST_STATUS_SUCCEEDED;

    actionToDo = getProductsByMarketSucceeded(productsByDepartment);
  } else {
    actionToDo = getProductsByMarketFailed(error);
  }

  yield put(actionToDo);

  if (action.callback){
    doCallback(action.callback, message, response ? productsByDepartment : null);
  }
}

function* getProductsByBenefitRequested(action) {

  const { response, error } = yield call(fetchProductsByMarketImages, action.token, action.idMarket);

  let actionToDo = null;
  let productsByDepartment = {};
  let productosByBenefit = {};
  let message = API_REQUEST_STATUS_FAILED;

  if(response) {
    message = API_REQUEST_STATUS_SUCCEEDED;

    productsByDepartment = getProductsByDepartment(response.data.productos, false, action.idMarket);
    productosByBenefit = getProductsByBenefit(productsByDepartment);

    actionToDo = getProductsByBenefitSucceeded(productosByBenefit);
  } else {
    actionToDo = getProductsByBenefitFailed(error);
  }

  yield put(actionToDo);

  if (action.callback){
    doCallback(action.callback, message, response ? productosByBenefit : null);
  }
}

function* finishPurchaseRequested(action) {
  const {purchase, metrics} = yield all({
    purchase: call(finishPurchase, action.token, action.term.bodyProducts),
    metrics: call(sendMetricsUser, action.token, action.term.bodyMetrics)
  })
  const { response, error } = purchase;
  let actionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if (response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    actionToDo = finishPurchaseSucceeded(response.data);
    updateMarketStorage(response.data, 'finishPurchase');
  } else {
    actionToDo = finishPurchaseFailed(error);
  }

  yield put(actionToDo);

  const { responseMetricsUser, errorMetricsUser } = metrics;

  if (responseMetricsUser) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    actionToDo = sendMetricsSucceeded(responseMetricsUser.data);
  } else {
    actionToDo = sendMetricsFailed(errorMetricsUser);
  }

  yield put(actionToDo);

  if (action.callback) {
    doCallback(action.callback, message);
  }

}

function* getResultsPDFRequested(action) {
  const { response, error } = yield call(getResultsPDF, action.token, action.term);

  let actionToDo = null;
  let message = API_REQUEST_STATUS_FAILED;

  if (response) {
    message = API_REQUEST_STATUS_SUCCEEDED;
    actionToDo = getResultsPDFSucceeded();
  } else {
    actionToDo = getResultsPDFFailed(error);
  }

  yield put(actionToDo);

  if (action.callback) {
    doCallback(action.callback, message,  response ? response.data : null );
  }

}

/* Sagas - Watchers/Listeners */
export function* watchGetProductsByMarket() {
  yield takeLatest(GET_PRODUCTS_BY_MARKET, getProductsByMarketRequested);
}

export function* watchGetProductsByBenefit() {
  yield takeLatest(GET_PRODUCTS_BY_BENEFIT, getProductsByBenefitRequested);
}

export function* watchFinishPurchase() {
  yield takeLatest(FINISH_PURCHASE, finishPurchaseRequested)
}

export function* watchGetResultsPDF() {
  yield takeLatest(GET_RESULTS_PDF, getResultsPDFRequested)
}

// ------------------------------------
// Exports Functions
// ------------------------------------

export const productsSagas = [
    watchGetProductsByMarket,
    watchGetProductsByBenefit,
    watchFinishPurchase,
    watchGetResultsPDF
];



// WEBPACK FOOTER //
// ./src/store/sagas/sagas_products.js